import defineCustomElement from 'vue3-webcomponent-wrapper'
import { createApp, h } from 'vue'
import './assets/styles.css'






//************ Elkostnadsräknaren *************//
import calc from './components/calc/StartCalc.vue'

const Calc = defineCustomElement(calc, createApp, h)

customElements.define("geab-vue-calc", Calc)



//************ Elkostnadsräknaren 2 - nyare Bootstrap *************//

import calc2 from './components/newCalc/StartCalc.vue'

const Calc2 = defineCustomElement(calc2, createApp, h)

customElements.define("geab-vue-calc2", Calc2)



//************ Historiska elpriser *************//
import historiskaPriser from './components/historiskaElpriser/App.vue'

const HistoriskaPriser = defineCustomElement(historiskaPriser, createApp, h)

customElements.define("geab-vue-hp", HistoriskaPriser)


//************ Historiska elpriser *************//
import historiskaPriserJamfor from './components/historicalPricesCompare/App.vue'

const HistoriskaPriserJamfor = defineCustomElement(historiskaPriserJamfor, createApp, h)

customElements.define("geab-vue-hp-jamfor", HistoriskaPriserJamfor)


//************ Elpriser Elhandelsshop *************//
import elpriserElhandelsshop from './components/elpriserElhandelsshop/App.vue'

const ElpriserElhandelsshop = defineCustomElement(elpriserElhandelsshop, createApp, h)

customElements.define("geab-vue-elpriser", ElpriserElhandelsshop)



//**PFU-Carousel**//

import CD from './components/cirkelDiagram/App.vue'

const CirkelDiagram = defineCustomElement(CD, createApp, h)

customElements.define("geab-vue-cirkel-diagram", CirkelDiagram)




//************ FAQ-box ************* ANVÄNDS EJ//
import faq from './components/faq/App.vue'

const FAQ = defineCustomElement(faq, createApp, h)

customElements.define("geab-vue-faq", FAQ)


//************ FAQ-box Bootstrap 5*************//
import faq3 from './components/faqBox/App.vue'

const FAQ3 = defineCustomElement(faq3, createApp, h)

customElements.define("geab-vue-faq2", FAQ3)



//************ Webb-FAQ ************* ANVÄNDS EJ//
import webbfaq from './components/webbFaq/App.vue'

const webbFaq = defineCustomElement(webbfaq, createApp, h)

customElements.define("geab-vue-webb-faq", webbFaq)

//************ Webb-FAQ Bootstrap 5*************//
import webbfaq2 from './components/webbFaq2/App.vue'

const webbFaq2 = defineCustomElement(webbfaq2, createApp, h)

customElements.define("geab-vue-webb-faq2", webbFaq2)


//************ App-FAQ *************//
import appfaq from './components/appFaq/App.vue'

const appFaq = defineCustomElement(appfaq, createApp, h)

customElements.define("geab-vue-app-faq", appFaq)


//*****Single-FAQ, används ex. i formulär ******//

import singlefaq from './components/singleFaq/App.vue'

const singleFaq = defineCustomElement(singlefaq, createApp, h)

customElements.define("geab-vue-single-faq", singleFaq)

//*****Single-FAQ, används ex. i formulär ******//

import singlefaqinternal from './components/singleFaqInternal/App.vue'

const singleFaqInternal = defineCustomElement(singlefaqinternal, createApp, h)

customElements.define("cockpit-vue-single-faq", singleFaqInternal)




//************ GOCkpit-FAQ *************//
import faq2 from './components/faq/Start.vue'

const FAQ2 = defineCustomElement(faq2, createApp, h)

customElements.define("geab-faq", FAQ2)



//**Notifications, krispuff, meddelanden högst upp på webbplatserna**//

import notification from './components/notifications/App.vue'

const Notification = defineCustomElement(notification, createApp, h)

customElements.define("geab-vue-notification", Notification)



//**Beräkna fjärrvärmekostnad**//

import fjv from './components/fjvKostnad/App.vue'

const FJV = defineCustomElement(fjv, createApp, h)

customElements.define("geab-vue-fjv-kostnad", FJV)



//**Spotpris**//

import spotpris from './components/spotPris/App.vue'

const spotPris = defineCustomElement(spotpris, createApp, h)

customElements.define("geab-vue-spotpris", spotPris)



//**Excelgenerator**//

import excelSheet from './components/excelSheet/App.vue'

const ExcelSheet = defineCustomElement(excelSheet, createApp, h)

customElements.define("geab-vue-excel", ExcelSheet)



//**Elhandelsshop**//

import elhandelsshop from './components/elhandelsshop/App.vue'

const Elhandelsshop = defineCustomElement(elhandelsshop, createApp, h)

customElements.define("geab-vue-elhandelsshop", Elhandelsshop)

 
//**Elhandelsshop**//

import elhandelsshoptest from './components/elhandelsshoptest/App.vue'

const Elhandelsshoptest = defineCustomElement(elhandelsshoptest, createApp, h)

customElements.define("geab-vue-elhandelsshop-test", Elhandelsshoptest)

 

//**PFU-Cards**//

import cards from './components/PFU/PFUCards.vue'

const Cards = defineCustomElement(cards, createApp, h)

customElements.define("geab-vue-pfu-cards", Cards)

//**PFU-Carousel**//

import carousel from './components/PFU/PFUCarousel.vue'

const Carousel = defineCustomElement(carousel, createApp, h)

customElements.define("geab-vue-pfu-carousel", Carousel)


//**Search-page**//

import searchpage from './components/search/App.vue'

const SearchPage = defineCustomElement(searchpage, createApp, h)

customElements.define("geab-vue-search", SearchPage)



//**Laddtransaktioner**//

import laddransaktioner from './components/laddTransaktioner/App.vue'

const Laddransaktioner = defineCustomElement(laddransaktioner, createApp, h)

customElements.define("geab-laddtransaktioner", Laddransaktioner)


//************ Driftavbrott  *************//

import driftavbrott from './components/driftavbrott/App.vue'

const Driftavbrott = defineCustomElement(driftavbrott, createApp, h)

customElements.define("geab-driftavbrott", Driftavbrott)


//************ Följ ditt ärende  *************//

import followcase from './components/followCase/App.vue'

const followCase = defineCustomElement(followcase, createApp, h)

customElements.define("geab-follow", followCase)


//************ TEST Webb-FAQ Bootstrap 5 TEST*************//
import webbfaq3 from './components/webbFaq2/AppTEST.vue'

const webbFaq3 = defineCustomElement(webbfaq3, createApp, h)

customElements.define("webb-faq-test", webbFaq3)


import emulateApp from './components/emulate/App.vue'

const emulate = defineCustomElement(emulateApp, createApp, h)

customElements.define("geab-emulate", emulate) 
